/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Tier_Free_Feature_5Inputs */

const en_pricing_tier_free_feature_5 = /** @type {(inputs: Pricing_Tier_Free_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload PDFs, but not word, MOBI, or EPUB`)
};

const es_pricing_tier_free_feature_5 = /** @type {(inputs: Pricing_Tier_Free_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sube PDFs, pero no Word, MOBI o EPUB`)
};

/**
* | output |
* | --- |
* | "Upload PDFs, but not word, MOBI, or EPUB" |
*
* @param {Pricing_Tier_Free_Feature_5Inputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_tier_free_feature_5 = /** @type {((inputs?: Pricing_Tier_Free_Feature_5Inputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Tier_Free_Feature_5Inputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_tier_free_feature_5(inputs)
	return en_pricing_tier_free_feature_5(inputs)
});